import styled from 'styled-components';

export const RecommendationPanel = styled.div`
  position: relative;
  padding: 24px;
  margin: 193px 26px;
  object-fit: contain;
  text-align: center;
  color: var(--dark-slate-blue);
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius:20px;
  background-color: #fff;
  width: 100%;
  max-width: 633px !important;
  gap: 24px;

  @media (min-width: 601px) {
    width: 633px;
  }
`;
